import { useCallback, useEffect, useRef, useState } from "react"

export const useFormValidator = (initialValidity = {}) => {
    const fieldsValidity = useRef(initialValidity);

    const [valid, setValid] = useState(false);
    const [formChanged, setFormChanged] = useState(false);

    const setFieldValidity = (field, valid) => {
        const newValidity = { ...fieldsValidity.current };
        newValidity[field] = valid;

        fieldsValidity.current = newValidity;

        validate();
    }

    const onFieldChange = () => setFormChanged(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const validate = () => {
        for (const field in fieldsValidity.current) {
            if (!fieldsValidity.current[field]) {
                setValid(false);
                return;
            }
        }

        setValid(true);
    }

    const resetValid = useCallback((validity) => {
        fieldsValidity.current = validity ? validity : initialValidity;
        validate();
    }, [initialValidity, validate])

    useEffect(() => {
        validate();
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    return [valid, setFieldValidity, resetValid, fieldsValidity, formChanged, onFieldChange]
}